// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MqSb","colBig":"styles_colBig__1zch5","colSmall":"styles_colSmall__1qPJV","shopifyNameWrapper":"styles_shopifyNameWrapper__2OEFl"};